var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "nav-wrapper md:sticky top-[0px] w-full bg-white relative z-50 roboto h-auto md:h-[150px] shadow-sm flex flex-wrap overflow-hidden",
    },
    [
      _c(
        "div",
        { staticClass: "pl-1 md:pl-0 md:ml-4 flex items-center h-full" },
        [
          _c("v-button", {
            staticStyle: { margin: "0px" },
            attrs: {
              position: "left",
              mobile: "12",
              tablet: "12",
              desktop: "12",
              styling: "tertiary",
              height: "20px",
              textAlign: "left",
              disabled: false,
            },
            on: { onClickEvent: _vm.backToOverview },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function () {
                  return [
                    _c(
                      "span",
                      { staticClass: "flex back-hover" },
                      [_c("BackArrow", { attrs: { fill: "#00263E" } })],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex h-full items-center flex-wrap" }, [
            _c("img", {
              staticClass: "max-w-[230px] image",
              attrs: {
                alt: _vm.productContent.name,
                src: _vm.activeOfferImage,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "text-wrapper h-fit inline-flex flex-wrap items-center justify-center my-0 mx-auto w-full",
              },
              [
                _c(
                  "p",
                  { staticClass: "text-2xl text-blue-dark mt-0 font-bold" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.globalContent.cartPage.customize) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-2xl text-blue-dark mt-0 font-bold" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.productContent.name) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }